import {create} from 'zustand';
import {Series} from "../models/interfaces/series.interface.ts";
import {SeriesDto} from "../models/interfaces/dtos/series.dto.interface.ts";
import {fetchSeries, fetchUserSeries, updateSeriesInfo} from "../services/seriesService.ts";
import {transformSingleSeriesDtoToSingleSeries} from "../utils/transformers/series.transformer.ts";
import {UserBulkSeriesDto} from "../models/interfaces/dtos/userBulkSeries.dto.interface.ts";

interface SeriesStore {
  seriesNameIdMapping: Record<string, string>;
  series: Record<string, Series>;
  getSeriesNameIdMapping: () => Promise<void>;
  getSeries: (seriesId: string) => Promise<void>;
  updateSeries: (series: Series) => Promise<void>;

}

export const useSeriesStore = create<SeriesStore>((set) => ({
  seriesNameIdMapping: {},
  series: {} as Record<string, Series>,
  getSeriesNameIdMapping: async (): Promise<void> => {
    try {
      const suerBulkSeriesDto: UserBulkSeriesDto[] = await fetchUserSeries()
      const seriesNameIdMapping: Record<string, string> = {};
      suerBulkSeriesDto.forEach((seriesDto: UserBulkSeriesDto) => {
        seriesNameIdMapping[seriesDto.name] = seriesDto._id;
      });
      set(() => ({seriesNameIdMapping}));

    } catch (error) {
      console.error('Error fetching series:', error);
      throw error;
    }

  },
  getSeries: async (seriesId: string): Promise<void> => {
    try {
      const seriesDto: SeriesDto = await fetchSeries(seriesId)
      const series: Series = transformSingleSeriesDtoToSingleSeries(seriesDto)
      set((state: SeriesStore) => ({
          series: {
            ...state.series,
            [seriesId]: series,
          },
        }
      ));
    } catch (error) {
      console.error('Error fetching series:', error);
      throw error;
    }
  },
  updateSeries: async (series: Series) => {
    try {
      const updatedSeriesDto: SeriesDto = await updateSeriesInfo(series.id, series.info);
      const updatedSeries: Series = transformSingleSeriesDtoToSingleSeries(updatedSeriesDto);

      set((state: SeriesStore) => ({
        series: {
          ...state.series,
          [series.id]: updatedSeries
        },
      }));
    } catch (error) {
      console.error('Error updating series:', error);
      throw error;
    }
  }
}));